import TakePhoto from "@/components/TakePhoto";

const components = {
  // SDoc
  rmDocTip: '请问你要删除这个文件吗？删除后无法恢复。',
  searchPlaceholder: '搜索文件或文件夹',
  upload: '上传',
  newFolder: '新建文件夹',
  folderNamePlaceholder: '请输入文件夹名称',
  cannotMoveToChild: '不能移动到子文件夹',
  moveSuccess: '移动成功',
  moveFail: '移动失败',
  moveToParent: '移动到上一级',
  move: '移动',
  moveTitle: '移动',
  moving: '正在移动: {{name}}',
  currentLocation: '当前位置',
  rootDirectory: '根目录',
  noFolders: '暂无文件夹',
  moveToHere: '移动到此处',
  cancel: '取消',

  // Dict
  plDictName: "请输入名称",
  plDictDesc: "请输入描述",
  dictName: '名称',
  dictDesc: '描述',

  // Selector
  plCountry: "请选择国家/地区",
  plCreditLevel: "请选择信用等级",
  plCurrency: "请选择币种",
  plProduct: "请选择商品",

  // 详情弹窗
  plContent: '请输入内容',
  send: '发送',
  reply: '回复',
  replyTo: '回复 {{name}}',
  cancelReply: '取消回复',
  replyCount: '{{name}} 条回复',
  collapseReplies: '收起回复',
  cameraUpload: '拍照上传',
  takePhoto: '拍照',
  switchCamera: '切换摄像头',
};

export default components;
